// extracted by mini-css-extract-plugin
export var base = "BaseInputMin-module--base--9fef8";
export var completed = "BaseInputMin-module--completed--e5575";
export var error = "BaseInputMin-module--error--a67e1";
export var group = "BaseInputMin-module--group--17c34";
export var withFrame = "BaseInputMin-module--withFrame--c27f4";